import axios from 'axios';

export const state = {}

export const getters = {}

export const mutations = {}


export const actions = {

  async requestHistory({ commit, dispatch, getters }, pagination = {}) {

    try{

      const { page, rowsPerPage, sortBy, descending, value } = pagination;

      const result  = await axios.post('fund-request/list',
        {
          where: {
            column: "status",
            value
          },
          search: null,
          strict: true,
          pagination: {
            page,
            rowsPerPage,
            sortBy,
            descending
          }
        });

      return { success: true, message: 'Funds list', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async actionFund({ commit, dispatch, getters }, requestAction = {}) {

    try{

      const { id, action } = requestAction;


      const result  = await axios.put('fund-request/action',
        {
          id,
          action
        });

      return { success: true, message: 'Fund action executed successfully!', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  }

}